import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { withFormik } from 'formik';

class UpdateBillingPeriod extends Component {
  renderButton = () => {
    const { toggle } = this.props;
    return (
      <Fragment>
        <span className="std-text blue pointer" onClick={toggle}>
          Change billing period
        </span>
      </Fragment>
    );
  };

  render() {
    const { isSubmitting, handleSubmit, toggle, isOpen, nextPlan } = this.props;
    return (
      <Fragment>
        {this.renderButton()}
        <Modal isOpen={isOpen} toggle={toggle} className={this.props.className}>
          <ModalHeader toggle={toggle}>
            <div className="h2-title">Change subscription plan</div>
          </ModalHeader>
          <div className="separator-line" />
          <ModalBody>
            <div className="profile-modal">
              <div className="profile-modal__info profile__inner bg">
                {nextPlan === 'monthly'
                  ? "Great move, you're about to save your self a bunch of money..20% to be exact..."
                  : 'You can’t upgrade from Annually to Monthly plan'}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              color="blue"
              className="m-r-15"
              disabled={nextPlan !== 'monthly'}
              onClick={handleSubmit}>
              {isSubmitting ? 'Loading' : 'Change'}
            </Button>{' '}
            <Button color="blue" className="outline" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

export default withFormik({
  handleSubmit: async (values, { props, setSubmitting, setErrors }) => {
    await props.handleSubmit(values, setSubmitting, setErrors);
  },
})(UpdateBillingPeriod);



// WEBPACK FOOTER //
// ./src/components/UpdateBillingPeriod/UpdateBillingPeriod.js